import React, { useState } from 'react';
import { RootReducersState } from 'redux/reducers';
import { useSelector } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import EnsureInsLogo from 'assets/images/retina-01-1.png';
import DevelopLogo from 'assets/images/develop-logo-02.png';
import { IProps } from './types';
import _ from 'lodash';
import * as LinkModels from 'bff/models/link';
import commonService from 'utils/commonService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import apiCommonService from 'bff/services/commonService';
import { RouterSettings } from 'constants/models/routerSettings';
import FunctionsItem00 from './FunctionsItem00';
import FunctionsItem01 from './FunctionsItem01';

const Header: React.FC<IProps> = (props) => {
  const isProduction = process.env.REACT_APP_MODE === 'prod';
  const [state, setState] = useState({
    mobileNavigationMenuActive: false,
    mobileSubNavigationVisible: false,
    activeSubNavigationName: ''
  });
  const [isLngActive, setIsLngActive] = useState<boolean>(false);
  const [isFavActive, setIsFavActive] = useState<boolean>(false);
  const [isLoginActive, setIsLoginActive] = useState<boolean>(false);
  const availOptions = useSelector((state: RootReducersState) => state.resources.availOptions);

  const toggleMobileNavigationMenu = () => {
    setState({ ...state, mobileNavigationMenuActive: !state.mobileNavigationMenuActive });
  };

  const toggleMobileSubNavigationVisible = (linkName: string) => {
    setState({
      ...state,
      mobileSubNavigationVisible: !state.mobileSubNavigationVisible,
      activeSubNavigationName: linkName
    });
  };

  /**
   * @description 會員登出
  */
  const handleLogOut = async (pathname: string) => {
    // props.onLogOut();
    // await apiCommonService.logOut();
    // props.history.replace(pathname);
    const logoutRes = await apiCommonService.logOut();
    if (logoutRes) {
      // 登出
      props.onLogOut();
      props.history.replace(RouterSettings.Home);
      storageService.clearAll.all();
      // 非投保作業頁面，登出後刷新頁面
      if (pathname.indexOf('/insure-process') === -1) {
        props.history.go(0);
      }
    }
  };

  /**
   * @description 點選登入或註冊事件
  */
  const handleRedirect = (e: React.MouseEvent<HTMLAnchorElement>, pathName: string) => {
    setIsLoginActive(false);
    e.preventDefault();
    const path = {
      pathname: pathName,
      state: { originUrl: props.location.pathname }
    };

    props.history.push(path);
  };

  // #region 產生 header 項目

  let headerItems = null;

  if (props.headerLinks.length > 0) {
    headerItems = _.map(props.headerLinks, (link: LinkModels.Link, index: number) => {
      const headerLinkUrl = commonService.validLoginState(link.LOGIN_REQUIRED, link.URL);

      let childElement: JSX.Element;

      if (link.CHILD && link.CHILD.length > 0) {
        childElement = (
          <div className="header__navigation-title" key={index}>
            <span>{link.NAME}</span>
            <div className="header__dropdown">
              <div className="header__dropdown-wrapper">
                <ul className="header__dropdown-nav">
                  {
                    _.map(link.CHILD, (childLink: LinkModels.BaseLink, index: number) => {
                      const childLinkTarget = commonService.getLinkTarget(childLink.NEW_WINDOW);
                      const childLinkUrl = commonService.validLoginState(childLink.LOGIN_REQUIRED, childLink.URL);
                      return (
                        <li key={index}>
                          <a href={childLinkUrl} rel="noopener noreferrer" target={childLinkTarget} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => commonService.validRedirect(childLink, e, props.history.push)}>{childLink.NAME}</a>
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
            </div>
          </div>
        );
      } else {
        childElement = <Link to={headerLinkUrl} className="header__navigation-title" key={index}>{link.NAME}</Link>;
      }

      return childElement;
    });
  }

  // #endregion

  // #region 產生 header mobile 項目

  let headerMobileItems;
  if (props.headerLinks.length > 0) {
    headerMobileItems = _.map(props.headerLinks, (link: LinkModels.Link, index: number) => {
      const linkUrl = commonService.validLoginState(link.LOGIN_REQUIRED, link.URL);

      let childElement: JSX.Element;

      if (link.CHILD && link.CHILD.length > 0) {
        childElement = (
          <div className={'header-mobile__navigation-item' + (state.mobileSubNavigationVisible && state.activeSubNavigationName === link.NAME ? ' header-mobile__navigation-item--active' : '')} key={index}>
            <div className="header-mobile__navigation-title" onClick={() => toggleMobileSubNavigationVisible(link.NAME)}>{link.NAME}</div>
            <div className="header-mobile__dropdown">
              <ul className="header-mobile__sub-navigation">
                {
                  _.map(link.CHILD, (childLink: LinkModels.BaseLink, index: number) => {
                    const childLinkTarget = commonService.getLinkTarget(childLink.NEW_WINDOW);
                    const childLinkUrl = commonService.validLoginState(childLink.LOGIN_REQUIRED, childLink.URL);
                    return (
                      <li key={index}>
                        <a href={childLinkUrl} rel="noopener noreferrer" target={childLinkTarget} className="header-mobile__sub-navigation-title" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => commonService.validRedirect(childLink, e, props.history.push)}>{childLink.NAME}</a>
                      </li>
                    );
                  })
                }
              </ul>
            </div>
          </div>
        );
      } else {
        childElement = (
          <div className="header-mobile__navigation-item" key={index}>
            <Link to={linkUrl} className="header-mobile__navigation-title" key={index} onClick={toggleMobileNavigationMenu}>{link.NAME}</Link>
          </div>
        );
      }

      return childElement;
    });
  }

  // #endregion

  /**
   * @description 判斷是否有收藏項目
   *
   */
  const favoriteListClass: string[] = ['header__functions-btn header__functions-btn--favorite'];
  if (props.hasFavoriteList) {
    favoriteListClass.push('header__functions-btn--active');
  }

  let memberSigninAndOut = (
    <div className="header__auth">
      <span>登入 / 註冊</span>
      <Link
        to={RouterSettings.Login}
        className="header__auth-btn header__auth-btn--highlight"
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleRedirect(e, RouterSettings.Login)}
      >登入
      </Link>
      <Link
        to={RouterSettings.Signup}
        className="header__auth-btn"
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleRedirect(e, RouterSettings.Signup)}
      >註冊
      </Link>
    </div>
  );
  if (props.fetchFavoriteComplete && storageService.getItem(storageKeys.LoginInfo)) {
    memberSigninAndOut = (
      <div className="header__auth">
        <span>{`${props.memberName} 您好！`}</span>
        <button type="button" className="header__auth-btn" onClick={() => handleLogOut(props.location.pathname)}>登出</button>
      </div>
    );
  }

  return (
    <header>
      {/* Web */}
      <div className="header">
        <div className="template-container">
          <div className="header__logo">
            <a href="https://www.wwunion.com/" rel="noopener noreferrer">
              <img
                src={isProduction ? EnsureInsLogo : DevelopLogo}
                alt={isProduction ? 'wwunion-ensure' : 'wwunion-ensure-develop'}
              />
            </a>
          </div>
          <nav className="header__navigation">
            {/* <Link to={RouterSettings.Home} className="header__navigation-title">網投首頁</Link> */}
            {headerItems}
          </nav>
          <div className="header__functions">
            <FunctionsItem01 id="lng-item" isActive={isLngActive} btnClassName="header__functions-btn--locale" text={availOptions.find(it => it.value === props.lng)?.text} onActive={(val) => setIsLngActive(val)}>
              <div className="header__auth">
                <span>{props.lng === 'zh' ? '選擇語系' : 'Language'}</span>
                {availOptions.map(it => (
                  <button
                    key={`lng-${it.value}`}
                    className={'header__auth-btn' + (props.lng === it.value ? ' header__auth-btn--highlight' : '')}
                    onClick={() => {
                      if (it.value !== props.lng) {
                        props.onLngChange(it.value);
                      }
                      setIsLngActive(false);
                    }}
                  >
                    {it.text}
                  </button>
                ))}
              </div>
            </FunctionsItem01>
            {/* <div style={{ cursor: 'pointer' }} className="header__functions-item">
              <div className="header__functions-btn header__functions-btn--locale">
                <span>{availOptions.find(it => it.value === props.lng)?.text}</span>
              </div>
              <div style={{ zIndex: 99 }} className="header__dropdown">
                <div className="header__dropdown-wrapper">
                  <div className="header__auth">
                    <span>{props.lng === 'zh' ? '選擇語系' : 'Language'}</span>
                    {availOptions.map(it => (
                      <button
                        key={`lng-${it.value}`}
                        className={'header__auth-btn' + (props.lng === it.value ? ' header__auth-btn--highlight' : '')}
                        onClick={() => {
                          if (it.value !== props.lng) {
                            props.onLngChange(it.value);
                          }
                        }}
                      >
                        {it.text}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}
            <FunctionsItem00 id="fav-item" isActive={isFavActive} onActive={(val) => setIsFavActive(val)}>
              <NavLink to={RouterSettings.FavoriteList} className={favoriteListClass.join(' ')} activeClassName="header__functions-btn--current">
                <span>收藏清單</span>
              </NavLink>
            </FunctionsItem00>
            {/* <div className="header__functions-item">
              <NavLink to={RouterSettings.FavoriteList} className={favoriteListClass.join(' ')} activeClassName="header__functions-btn--current">
                <span>收藏清單</span>
              </NavLink>
            </div> */}
            <FunctionsItem01 id="login-item" isActive={isLoginActive} btnClassName="header__functions-btn--user" onActive={(val) => setIsLoginActive(val)}>
              {memberSigninAndOut}
            </FunctionsItem01>
            {/* <div className="header__functions-item">
              <div className="header__functions-btn header__functions-btn--user" />
              <div style={{ zIndex: 99 }} className="header__dropdown">
                <div className="header__dropdown-wrapper">
                  {memberSigninAndOut}
                </div>
              </div>
            </div> */}
            <div className="header__functions-item">
              {
                /*
                  <div className="header__search-section">
                    <div className="header__functions-btn header__functions-btn--search" />
                    <div className="header__search-bar">
                      <div className="header__search-bar-wrapper">
                        <input type="text" className="header__search-input" placeholder="搜尋..." />
                      </div>
                    </div>
                  </div>
                */
              }
              {/* mobile menu */}
              <div className="header-mobile__menu-section">
                <button type="button" className="header-mobile__menu-btn" onClick={toggleMobileNavigationMenu} />
                <div className={'header-mobile__menu' + (state.mobileNavigationMenuActive ? ' header-mobile__menu--active' : '')}>
                  <div className="header-mobile__menu-container">
                    <div className="header-mobile__search-bar">
                      <input type="text" className="header-mobile__search-input" placeholder="搜尋..." style={{ display: 'none' }} />
                    </div>
                    <nav className="header-mobile__navigation">
                      {/* <div className="header-mobile__navigation-item">
                        <Link to={RouterSettings.Home} className="header-mobile__navigation-title" onClick={toggleMobileNavigationMenu}>網投首頁</Link>
                      </div> */}
                      {headerMobileItems}
                    </nav>
                  </div>
                  <div className="header-mobile__menu-background" onClick={toggleMobileNavigationMenu} />
                </div>
              </div>
              {/* mobile menu end */}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default withRouter(Header);
